import { Map as ImmutableMap, List } from 'immutable';
import setIn from 'immutable-less/transmute/setIn';
import getIn from 'immutable-less/transmute/getIn';
import * as ActionTypes from 'automation-ui-canvas/actions/ActionTypes';
import * as RequestStatus from 'automation-ui-canvas/constants/RequestStatus';

////////////////
// Example State:
// indexedValues{
//   [flowId]:
//     [actionId]: {
//       requestStatus: status, object: List, hasMore: bool, offset: {}
//     }
//   }
// }
////////////////
export const initialState = ImmutableMap({
  indexedValues: {}
});
export default ((state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUESTED_DELAYED_OBJECTS:
      {
        const {
          actionId,
          flowId
        } = action.payload;
        return setIn(['indexedValues', flowId, actionId, 'requestStatus'], RequestStatus.PENDING, state);
      }
    case ActionTypes.RECEIVED_DELAYED_OBJECTS:
      {
        const {
          actionId,
          flowId,
          response: {
            results,
            hasMore,
            offset
          }
        } = action.payload;
        const existingObjects = getIn(['indexedValues', flowId, actionId, 'objects'], state) || List();
        const newObjects = existingObjects.concat(results);
        const flowActionData = ImmutableMap({
          requestStatus: RequestStatus.SUCCEEDED,
          objects: newObjects,
          hasMore,
          offset
        });
        return setIn(['indexedValues', flowId, actionId], flowActionData, state);
      }
    case ActionTypes.REQUESTED_DELAYED_OBJECTS_FAILED:
      {
        const {
          actionId,
          flowId
        } = action.payload;
        return setIn(['indexedValues', flowId, actionId, 'requestStatus'], RequestStatus.FAILED, state);
      }
    case ActionTypes.CLEAR_DELAYED_OBJECTS:
      {
        const {
          actionId,
          flowId
        } = action.payload;
        return setIn(['indexedValues', flowId, actionId], ImmutableMap(), state);
      }
    case ActionTypes.MARK_OBJECTS_AS_UNENROLLED:
      {
        const {
          actionId,
          flowId,
          objectIds
        } = action.payload;
        const existingObjects = getIn(['indexedValues', flowId, actionId, 'objects'], state) || List();
        const objects = List(existingObjects.map(obj => Object.assign({}, obj, {
          toBeUnenrolled: objectIds.includes(obj.objectId)
        })));
        return setIn(['indexedValues', flowId, actionId, 'objects'], objects, state);
      }
    default:
      return state;
  }
});